import { DropzonePhase } from "./dropzone.enum.es.js";
import { parseErrorMessage } from "../../../utils/parsing/parsing.es.js";
import { isFunction } from "../../../utils/type-checking/type-checking.es.js";
function handleOnDropEventAndReturnNewStatus(acceptedFiles, fileRejections, event, onDrop, onDropError) {
  const newStatus = createNewStatus(DropzonePhase.SelectedFiles, mapAcceptedFiles(acceptedFiles));
  if (!isFunction(onDrop)) {
    return newStatus;
  }
  try {
    onDrop(acceptedFiles, fileRejections, event);
    return newStatus;
  } catch (onDropCallbackError) {
    handleCallbackError(onDropCallbackError, onDropError);
    return createNewStatus(DropzonePhase.Invalid, mapAcceptedFiles(acceptedFiles), parseErrorMessage(onDropCallbackError));
  }
}
async function handleOnConfirmEventAndReturnNewStatus(files, onConfirm, onConfirmError) {
  const newStatus = createNewStatus(DropzonePhase.ConfirmedFiles, mapAcceptedFiles(files ?? []));
  if (!isFunction(onConfirm)) {
    return newStatus;
  }
  try {
    await onConfirm(files);
    return newStatus;
  } catch (onConfirmCallbackError) {
    handleCallbackError(onConfirmCallbackError, onConfirmError);
    return createNewStatus(DropzonePhase.Invalid, mapAcceptedFiles(files ?? []), parseErrorMessage(onConfirmCallbackError));
  }
}
async function handleClearButtonClickEventAndReturnNewStatus(event, onClear, onClearError) {
  event.stopPropagation();
  event.preventDefault();
  const newStatus = createNewStatus(DropzonePhase.Empty);
  if (!isFunction(onClear)) {
    return newStatus;
  }
  try {
    onClear();
  } catch (onClearCallbackError) {
    handleCallbackError(onClearCallbackError, onClearError);
  }
  return null;
}
function handleModifyButtonEventAndReturnNewStatus(dropzoneStatus, onModify, onModifyError) {
  const newStatus = createNewStatus(DropzonePhase.SelectedFiles, dropzoneStatus.acceptedFiles);
  if (isFunction(onModify)) {
    try {
      onModify();
    } catch (onModifyCallbackError) {
      handleCallbackError(onModifyCallbackError, onModifyError);
    }
  }
  return newStatus;
}
function createNewStatus(phase, acceptedFiles, message) {
  return {
    phase,
    acceptedFiles: acceptedFiles ?? [],
    message
  };
}
function handleCallbackError(error, errorCallback) {
  if (isFunction(errorCallback)) {
    errorCallback(error);
  }
}
function mapAcceptedFiles(acceptedFiles) {
  return acceptedFiles.map((f) => {
    return {
      file: f,
      url: URL.createObjectURL(f)
    };
  });
}
export {
  handleClearButtonClickEventAndReturnNewStatus,
  handleModifyButtonEventAndReturnNewStatus,
  handleOnConfirmEventAndReturnNewStatus,
  handleOnDropEventAndReturnNewStatus
};
//# sourceMappingURL=handler-functions.es.js.map
